import PropTypes from 'prop-types';

export default function Tile({ feature, categories }) {
	const TileElement = feature.content_url ? 'a' : 'div';
	const tileProps = {
		className: 'tile tile--image-size-regular',
	};
	if (feature.content_url) {
		tileProps.href = feature.content_url;
	}

	if (feature.primary_category) {
		tileProps.style = { '--color': categories[feature.primary_category].color };
	}

	return (
		<TileElement {...tileProps}>
			<div className="tile__container">
				<header className="tile__header">
					<div className="tile__icon" dangerouslySetInnerHTML={{ __html: feature.icon }} />
					<p className="h6" dangerouslySetInnerHTML={{ __html: feature.name }}></p>
				</header>
				<div className="tile__content">
					<p dangerouslySetInnerHTML={{ __html: feature.desc_grid }}></p>
				</div>
				{feature.primary_category && (
					<footer className="tile__footer">
						<div className="tile__category">{categories[feature.primary_category].title}</div>
					</footer>
				)}
			</div>
		</TileElement>
	);
}

Tile.propTypes = {
	feature: PropTypes.object,
	categories: PropTypes.object,
};
